<template>
  <div class="filter-bar">
    <publish-options v-if="userRoles && userRoles.length"></publish-options>
    <aside class="library-filters">
      <section
        class="section"
        :class="{ open: isIdIncluded(keyClassification.id) }"
        v-for="keyClassification in classificationTree"
        :key="keyClassification.id"
      >
        <div @click="toggleDetails(keyClassification.id)">
          <p class="section-title">
            {{ keyClassification.title }}
          </p>
        </div>
        <div
          v-if="keyClassification.values && isIdIncluded(keyClassification.id)"
          class="dropdown-content"
        >
          <ul class="dropdown-list">
            <classifications-details
              v-for="value in keyClassification.values"
              :key="value.id"
              :classifications="value"
              :classificationKey="keyClassification.title"
              :classificationKeyId="keyClassification.id"
              :mode="'filter-bar'"
            />
          </ul>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
import Vuex from 'vuex'
import PublishOptions from '@/components/publish-options'
import ClassificationsDetails from '@/components/classifications-details'

export default {
  name: 'filter-bar',
  components: { PublishOptions, ClassificationsDetails },
  data () {
    return {
      keyClassificationsValues: []
    }
  },
  computed: {
    ...Vuex.mapState({
      classificationTree: state => state.classifications.classifications,
      userRoles: state => state.base.userRoles
    })
  },
  mounted () {
    if (this.classificationTree) {
      for (let i = 0; i < this.classificationTree.length; i++) {
        this.keyClassificationsValues.push(this.classificationTree[i].id)
      }
    }
  },
  watch: {
    classificationTree () {
      if (!this.keyClassificationsValues.length) {
        for (let i = 0; i < this.classificationTree.length; i++) {
          this.keyClassificationsValues.push(this.classificationTree[i].id)
        }
      }
    }
  },
  methods: {
    toggleDetails (id) {
      if (this.isIdIncluded(id)) {
        const index = this.keyClassificationsValues.indexOf(id)
        this.keyClassificationsValues.splice(index, 1)
      } else {
        this.keyClassificationsValues.push(id)
      }
    },
    isIdIncluded (id) {
      if (this.keyClassificationsValues.includes(id)) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.section-title:before{
  background-image: url("../assets/images/arrow_categories.svg");
}
</style>
